import HInputGroup from "../../main/components/HInputGroup.tsx";

interface NomPrenomDDNProps {
  birthdate: string;
  name: string;
  forename: string;
  showPrenom: boolean;
  onBirthdateChange: (value: string) => void;
  isValidDdn: boolean;
  onNameChange: (value: string) => void;
  onForenameChange: (value: string) => void;
}

const scroll2 = () => {
  document.querySelector("#ddn_lookup")?.scrollIntoView({ behavior: "smooth" });
  // try {
  //   $("html, body").animate(
  //     {
  //       scrollTop: $("#ddn_lookup").offset().top
  //     },
  //     500
  //   );
  // } catch (e) {}
};

export default (props: NomPrenomDDNProps) => {
  const birthdate = props.birthdate;
  const name = props.name;
  const forename = props.forename;
  const { showPrenom } = props;
  const { onBirthdateChange } = props;
  const { isValidDdn } = props;
  const isValidPrenom = forename.length > 1;
  const { onNameChange } = props;
  const { onForenameChange } = props;
  const prenomComp = () => {
    return (
      <div className={"form-group"}>
        <HInputGroup
          label="Prénom"
          value={forename}
          onChange={onForenameChange}
          id="prenom_input_fiche_appel"
          labelWidth="100px"
          inputWidth="300px"
          isValid={isValidPrenom}
          isTouched={!!forename}
        />
      </div>
    );
  };
  const variableComp = showPrenom ? prenomComp() : <span></span>;
  return (
    <div>
      <HInputGroup
        label="Date de Naissance"
        value={birthdate}
        onChange={onBirthdateChange}
        id="ddn_lookup"
        labelWidth="100px"
        inputWidth="300px"
        isValid={isValidDdn}
        isTouched={!!birthdate}
      />

      <HInputGroup
        label="Nom"
        value={name}
        onChange={onNameChange}
        id="nom_lookup"
        labelWidth="100px"
        inputWidth="300px"
        isTouched={!!name}
        isValid={name.length > 1}
      />
      {variableComp}
    </div>
  );
};
